import { schemaTypes, dateFormat } from "../../../constants/constants";

const schema = {
  key: "group_report",
  name: "Group Report",
  toolbar: [],
  content: [
    {
      key: "group_report",
      name: "Group Report",
      type: schemaTypes.GROUP_REPORT,
      position: {
        width: 12,
        height: 12,
        left: 0,
        top: 0,
      },
    },
  ],
};
export default schema;
